function setFormValidation({ input, state }) {
  state.set('client.forms.validation', {
    valid: input.valid,
    section: input.section
  })
}

export default setFormValidation



// WEBPACK FOOTER //
// ./src/modules/user/actions/setFormValidation.js